var options={use:false,top:[],bottom:[],position:'left',type:'default'};export default options;